import AnalyticsPageContent from '@/components/AnalyticsPage'

export default function AnalyticsPage() {
  return <AnalyticsPageContent />
}

